import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Tab } from 'component/base'
import { Custom } from 'component/pieces'

export const Hanbaisaki = props => {
  const { multiple, setSelectedId, selectedId } = props

  const [loading, setLoading] = useState(false)

  return (
    <Tab
      panes={[
        {
          menuItem: '組合員',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.Kumiaiin
                mode='hanbaisaki'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: '販売先（外部）',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.Hanbaisaki
                mode='hanbaisaki'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
              />
            </Tab.Pane>
          ),
        },
        {
          menuItem: '単組他',
          render: () => (
            <Tab.Pane>
              <Custom.DataTable.TansoSeikyuShiharaisaki
                mode='torihikisaki'
                onSelectChange={selectedId => setSelectedId(selectedId)}
                multiple={multiple}
                selectedId={selectedId}
                loading={loading}
                setLoading={setLoading}
              />
            </Tab.Pane>
          ),
        },
      ]}
    />
  )
}

Hanbaisaki.propTypes = {
  multiple: PropTypes.bool,
  setSelectedId: PropTypes.func,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Hanbaisaki.defaultProps = {
  multiple: false,
  setSelectedId: () => {},
  selectedId: undefined,
}
